var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_vm._v(" CMDRPW ")]),_c('v-spacer')],1),_c('v-main',[_c('HelloWorld')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }